import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Button, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

import { createIndividualInvestment } from "../../actions/individualInvestment";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

import EditIcon from "@mui/icons-material/Edit";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import toast from "react-hot-toast";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "25px",
  transform: "translate(-50%, -50%)",
  width: 700,
  // height: 500,
  bgcolor: "white",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const columns = [
  { id: "code", label: "Code", minWidth: 100 },
  { id: "investment_type", label: "Investment type", minWidth: 200 },
  {
    id: "regulator",
    label: "Regulator",
    minWidth: 170,
    align: "right",
  },
  {
    id: "cost",
    label: "Cost",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "rate",
    label: "Rate",
    minWidth: 170,
    align: "right",
  },
  {
    id: "year_days",
    label: "Year days",
    minWidth: 170,
    align: "right",
  },
  {
    id: "purchase_date",
    label: "Purchase date",
    minWidth: 170,
    align: "right",
  },
  {
    id: "maturity_date",
    label: "Maturity date",
    minWidth: 170,
    align: "right",
  },
];
function createData(
  id,
  code,
  investment_type,
  regulator,
  cost,
  rate,
  year_days,
  purchase_date,
  maturity_date
) {
  return {
    id,
    code,
    investment_type,
    regulator,
    cost,
    rate,
    year_days,
    purchase_date,
    maturity_date,
  };
}
export default function IndividualInvest() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [open, setOpen] = React.useState(false);
  const [openDetail, setOpenDetail] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleCloseDetail = () => setOpenDetail(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const investmentTypes = useSelector((state) => state.investmentTypes);
  const regulators = useSelector((state) => state.regulators);
  const institutions = useSelector((state) => state.institution);
  const investments = useSelector((state) => state.individualInvestment);
  let num = investments.length + 1;

  function code(num) {
    if (num < 10) {
      return "000" + num;
    } else if (num >= 10 && num < 100) {
      return "00" + num;
    } else if (num >= 100 && num < 1000) {
      return "0" + num;
    } else {
      return num.toString();
    }
  }

  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  let [investmentData, setInvestmentData] = React.useState({
    cost: "",
    rate: "",
    discount_rate: "",
    purchase_date: "",
    maturity_date: "",
    year_days: "",
    charges: "",
    investment_type: "",
    institution: "",
    regulator: "",
    certificate_number: "",
    code: "",
    uploaded_by: user.results.firstName + " " + user.results.lastName,
    tenure: "",
    daily_interest: "",
    total_interest: "",
    rate_type: "",
    name: "",
    account_number: "",
  });
  const rate = investmentData.rate / 100;
  const investment_interest =
    investmentData.cost *
    rate *
    (investmentData.tenure / investmentData.year_days);
  const daily_interest =
    (
      (investment_interest - investmentData.charges) /
      investmentData.tenure
    ).toFixed(8) * 1;
  const maturity_date = moment(investmentData.purchase_date).add(
    investmentData.tenure,
    "days"
  );
  investmentData.maturity_date = moment(maturity_date._d).format("YYYY-MM-DD");
  investmentData.total_interest = investment_interest - investmentData.charges;
  investmentData.daily_interest = daily_interest;
  const regCode = investmentData.regulator
    ? regulators.filter(
        (data) => data.regulator === investmentData.regulator
      )[0].code
    : "";

  const instCode = investmentData.investment_type
    ? investmentTypes
        .filter(
          (data) => data.investment_type === investmentData.investment_type
        )[0]
        .code.toLowerCase()
    : "";

  const investmentCode = `AARB/IND/${regCode}/${instCode}/${new Date(
    investmentData.purchase_date
  ).getFullYear()}/${code(num)}`;

  investmentData.code = investmentCode;
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const dispatch = useDispatch();
  function sendData() {
    try {
      if (
        investmentData.cost &&
        investmentData.rate &&
        investmentData.purchase_date &&
        investmentData.maturity_date &&
        investmentData.year_days &&
        investmentData.charges &&
        investmentData.investment_type &&
        investmentData.institution &&
        investmentData.regulator &&
        investmentData.name &&
        investmentData.account_number &&
        investmentData.certificate_number
      ) {
        dispatch(createIndividualInvestment(investmentData));
        clear();
      } else {
        toast.error("Please fill in all required fields");
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
  function clear() {
    setInvestmentData({
      cost: "",
      rate: "",
      discount_rate: "",
      purchase_date: "",
      maturity_date: "",
      year_days: "",
      charges: "",
      investment_type: "",
      institution: "",
      regulator: "",
      certificate_number: "",
      code: "",
      uploaded_by: user.results.firstName + " " + user.results.lastName,
      tenure: "",
      daily_interest: "",
      total_interest: "",
      rate_type: "",
    });
  }
  const rows = investments.map((data) =>
    createData(
      data._id,
      data.code,
      data.investment_type,
      data.regulator,
      data.cost,
      data.rate,
      data.year_days,
      moment(data.purchase_date).format("DD-MM-YYYY"),
      moment(data.maturity_date).format("DD-MM-YYYY")
    )
  );

  let allowManipulate = false;
  if (
    user?.results?.portfolio_manager === "Administrator" ||
    user?.results?.portfolio_manager === "Read-Write"
  ) {
    allowManipulate = true;
  } else {
    allowManipulate = false;
  }

  return (
    <div>
      <Paper sx={{ width: "100%" }}>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id="transition-modal-title"
                variant="h5"
                component="h2"
                style={{ marginBottom: "15px" }}
              >
                Add Customer Investment
              </Typography>
              <form
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "20px",
                  justifyContent: "space-around",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="text"
                    size="small"
                    label="Customer Name"
                    required
                    value={investmentData.name}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        name: e.target.value,
                      })
                    }
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="number"
                    size="small"
                    label="cost"
                    required
                    value={investmentData.cost}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        cost: e.target.value,
                      })
                    }
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="number"
                    size="small"
                    label="rate(%)"
                    required
                    value={investmentData.rate}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        rate: e.target.value,
                      })
                    }
                  />
                  <FormControl
                    size="small"
                    variant="standard"
                    sx={{ m: 1, minWidth: 120 }}
                  >
                    <InputLabel required id="demo-simple-select-standard-label">
                      rate type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.rate_type}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          rate_type: e.target.value,
                        })
                      }
                      label="investment type"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value="discount rate">discount rate</MenuItem>
                      <MenuItem value="interest rate">interest rate</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="date"
                    size="small"
                    label="purchase Date"
                    value={investmentData.purchase_date}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        purchase_date: e.target.value,
                      })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="text"
                    size="small"
                    label="Tenure"
                    value={investmentData.tenure}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        tenure: e.target.value,
                      })
                    }
                    required
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="date"
                    size="small"
                    label="Maturity date"
                    disabled
                    value={investmentData.maturity_date}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        maturity_date: e.target.value,
                      })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />

                  <div>
                    <Button
                      onClick={sendData}
                      variant="contained"
                      size="small"
                      style={{
                        textTransform: "none",
                        margin: "5px",
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                      }}
                      onClick={handleClose}
                      size="small"
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                        marginLeft: "8px",
                      }}
                      onClick={clear}
                      size="small"
                    >
                      Clear form
                    </Button>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel required id="demo-simple-select-standard-label">
                      Year days
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.year_days}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          year_days: e.target.value,
                        })
                      }
                      label="Category"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={364}>364</MenuItem>
                      <MenuItem value={365}>365</MenuItem>
                      <MenuItem value={366}>366</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="number"
                    size="small"
                    label="charges"
                    value={investmentData.charges}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        charges: e.target.value,
                      })
                    }
                    required
                  />
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel required id="demo-simple-select-standard-label">
                      Investment type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.investment_type}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          investment_type: e.target.value,
                        })
                      }
                      label="Category"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {investmentTypes.map((data) => (
                        <MenuItem key={data._id} value={data.investment_type}>
                          {data.investment_type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel required id="demo-simple-select-standard-label">
                      Institution
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.institution}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          institution: e.target.value,
                        })
                      }
                      label="Age"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {institutions.map((data) => (
                        <MenuItem key={data._id} value={data.institution}>
                          {data.institution}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel required id="demo-simple-select-standard-label">
                      Regulator
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={investmentData.regulator}
                      onChange={(e) =>
                        setInvestmentData({
                          ...investmentData,
                          regulator: e.target.value,
                        })
                      }
                      label="Age"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {regulators.map((data) => (
                        <MenuItem key={data._id} value={data.regulator}>
                          {data.regulator}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    type="text"
                    size="small"
                    style={{ marginBottom: "10px" }}
                    label="Customer Acct. number"
                    required
                    value={investmentData.account_number}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        account_number: e.target.value,
                      })
                    }
                  />
                  <TextField
                    type="text"
                    size="small"
                    style={{ marginBottom: "10px" }}
                    label="Certificate/Tender number"
                    required
                    value={investmentData.certificate_number}
                    onChange={(e) =>
                      setInvestmentData({
                        ...investmentData,
                        certificate_number: e.target.value,
                      })
                    }
                  />
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        {openDetail && (
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDetail}
            onClose={handleCloseDetail}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDetail}>
              <Box sx={style}>
                <Typography
                  id="transition-modal-title"
                  variant="h5"
                  component="h2"
                  style={{ marginBottom: "15px" }}
                >
                  Investment Details
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "20px",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset code"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset pool"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset location"
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset description"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="purchase date"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="exhaustion date"
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset cost"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="daily depreciation"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="depreciation rate"
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="supplier"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="uploaded by"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="approval status"
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="revaluation status"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="revalued by"
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="disposal status"
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="disposed by"
                    />
                    <div>
                      <Button
                        style={{
                          textTransform: "none",
                          marginRight: "10px",
                          backgroundColor: "#17B859",
                        }}
                        variant="contained"
                        size="small"
                      >
                        Edit
                        <EditIcon style={{ fontSize: "18px" }} />
                      </Button>
                      <Button
                        style={{
                          textTransform: "none",
                          marginRight: "5px",
                          backgroundColor: "#116149",
                        }}
                        variant="contained"
                        size="small"
                      >
                        Submit <SendIcon style={{ fontSize: "18px" }} />
                      </Button>
                    </div>
                  </Box>
                </div>
              </Box>
            </Fade>
          </Modal>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            size="small"
            disabled={!allowManipulate}
            style={{
              textTransform: "capitalize",
              margin: "5px",
            }}
            onClick={handleOpen}
            variant="contained"
          >
            Add Customer Investment
          </Button>
        </div>
        <em style={{ color: "red" }}>
          {allowManipulate ? "" : "you don't have the permission to add asset"}
        </em>
        <TableContainer sx={{ maxHeight: 740 }}>
          <Table size="small" stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#f8f8f8",
                      color: "#000",
                      fontWeight: "bold",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
